import _ from 'lodash';
let pendingRefresh;
/* @ngInject */
export default class RcuInfoService {
    $q;
    $sails;
    $log;
    rcuModel;
    constructor($q, $sails, $log) {
        this.$q = $q;
        this.$sails = $sails;
        this.$log = $log;
        $sails.on('rcu:created', this.addRcu.bind(this));
        $sails.on('rcu:updated', this.updateRcu.bind(this));
        $sails.on('rcu:destroyed', this.deleteRcu.bind(this));
        // model const to store object of all of the rcu in an object where the key is
        // the rcuId and the value is the whole rcu object.
        // this is done for quickly accessing rcu rather than iterating over the array
        // comparing id's, as well as storing in a model const so it is passed by reference that doesn't
        // change
        this.rcuModel = {
            rcuAsObject: {},
            rcuAsArray: []
        };
    }
    filterTheRcus(listOfRcuIds) {
        const rcus = _.map(listOfRcuIds, rcuId => this.rcuModel.rcuAsObject[rcuId]);
        // remove rcus from the array that cannot be found.
        return _.without(rcus, null);
    }
    subscribeToAdmin() {
        return this.$sails.post('/admin/subscribeToAdmin', {});
    }
    unsubscribeToAdmin() {
        return this.$sails.post('/admin/unsubscribeToAdmin', {});
    }
    refreshRcuListFromServer() {
        return pendingRefresh || this.$sails.get('/rcu/')
            .then(({ data: rcus }) => {
            this.rcuModel.rcuAsArray = rcus;
            this.rcuModel.rcuAsObject = _.reduce(this.rcuModel.rcuAsArray, (memo, rcu) => {
                // * Hack for RCUs == (eq) Node type handling
                rcu.equipmentType = 'RCU';
                if (!rcu.kind) {
                    rcu.kind = 'PHYSICAL';
                }
                return _.assign(memo, { [rcu.id]: rcu });
            }, {});
        })
            .catch((error) => {
            this.$log.error('Error: ', error);
            return this.$q.reject(error.data);
        })
            .finally(() => {
            pendingRefresh = undefined;
        });
    }
    filterRcusById(listOfRcuIds) {
        return this.$q.resolve(_.size(this.rcuModel.rcuAsObject) ?
            this.filterTheRcus(listOfRcuIds) :
            this.refreshRcuListFromServer()
                .then(() => this.filterTheRcus(listOfRcuIds))
                .catch((error) => {
                this.$log.error(error);
                return this.$q.reject(`Could not filter rcu's: ${error}`);
            }));
    }
    getAllRcus() {
        return this.$q.resolve(_.get(this.rcuModel.rcuAsArray, 'length', 0) ?
            this.rcuModel.rcuAsArray :
            this.refreshRcuListFromServer()
                .then(() => this.rcuModel.rcuAsArray)
                .catch((error) => {
                this.$log.error(error);
                return this.$q.reject(`Could not get all rcu's: ${error}`);
            }));
    }
    getRcuById(id) {
        return this.filterRcusById([id])
            .then(success => success[0]);
    }
    addRcu(newRcu) {
        this.rcuModel.rcuAsArray.push(newRcu);
        this.rcuModel.rcuAsObject[newRcu.id] = newRcu;
        return newRcu;
    }
    updateRcu(updatedRcu) {
        _.forEach(this.rcuModel.rcuAsArray, (val) => {
            if (val.id === updatedRcu.id) {
                _.merge(val, updatedRcu);
                return false;
            }
            return true;
        });
        this.rcuModel.rcuAsObject[updatedRcu.id] = updatedRcu;
        return updatedRcu;
    }
    deleteRcu(deletedRcu) {
        _.forEach(this.rcuModel.rcuAsArray, (val, theFuckingIndex, rcuArr) => {
            if (val.id === deletedRcu.id) {
                rcuArr.splice(theFuckingIndex, 1);
                return false;
            }
            return true;
        });
        delete this.rcuModel.rcuAsObject[deletedRcu.id];
    }
}
